import _ from 'lodash';
import moment from 'moment';
import momentTz from 'moment-timezone';

// Utils
import { EVENT_OBJECT_TYPES } from '../constants/event';
import { convertMeterToMile, convertSecondToHour } from './convert';
import colors from '../themes/colors';

const defaultTimezone = momentTz.tz.guess();

const separateObject = (obj) => {
  if (!obj) {
    return {
      object_type: '',
      object_id: '',
    };
  }
  const { uid } = obj;
  if (!uid) {
    return {
      object_type: '',
      object_id: '',
    };
  } else {
    const type = uid.split('_')[0];
    const objectType = EVENT_OBJECT_TYPES[type] ? EVENT_OBJECT_TYPES[type] : type;
    const objectID = uid.split('_')[1];
    return {
      object_type: objectType,
      object_id: objectID,
    };
  }
};

const getDotColor = (color, event) => {
  if (color != null && color.startsWith('$.')) {
    const colorField = color.replace('$.', '');
    const colorFieldValue = _.get(event, colorField, '');

    if (!colorFieldValue) return colors.grayMain;
    if (['SUCCEEDED', 'GEOCODED', 'DROPOFF_SUCCEEDED', 'RECEIVED_OK', 'SUCCESSED'].includes(colorFieldValue)) return colors.lightGreen;
    if (['EN_ROUTE', 'COMING_SOON', 'PICKUP_SUCCEEDED', 'PICKUPED'].includes(colorFieldValue)) return colors.main;
    if (['READY', 'ROUTED', 'PICKUP_READY', 'DROPOFF_READY'].includes(colorFieldValue)) return colors.lightOrange;
    if (['FAILED', 'GEOCODE_FAILED', 'DROPOFF_FAILED', 'PICKUP_FAILED'].includes(colorFieldValue)) return colors.red;
    return colors.grayMain;
  }
  return color;
};

const transformEventMap = (date, dataEvents, templates, owners = []) => {
  dataEvents = dataEvents.flatMap((e) => {
    let d = moment(e.ts).format('dddd M/D/YYYY').toUpperCase();
    if (d === date) return [e];
    else {
      date = d;
      return [{ signal: 'DATE', date: d }, e];
    }
  });

  const dataTemplates = templates.data;
  let dataMap = new Map();
  for (const e of dataEvents) {
    let template = dataTemplates.find((f) => f.category === e.category && f.action === e.action && f.type === e.type);

    if (!template && owners) {
      // get default templates with owners prioritize
      const listDefaultTemplates = dataTemplates.filter((f) => f.category === 'DEFAULT' && f.type === 'DEFAULT' && f.action === 'default');

      const matchedTemplates = owners.map((o) => listDefaultTemplates.find((tmp) => tmp.owners.includes(o))).filter((tmp) => !!tmp);
      template = matchedTemplates.shift();
    }

    if (!template) {
      // get default template
      template = dataTemplates.find((f) => f.category === 'DEFAULT' && f.type === 'DEFAULT' && f.action === 'default');
    }

    if (!template?.hidden && e.signal !== 'DATE') {
      const subject = separateObject(e.subject);
      const object = separateObject(e.object);
      const rel = separateObject(e.rel);
      const ref = separateObject(e.ref);
      const source = separateObject(e.source);
      dataMap.set(e.id, {
        origin: e,
        converted: {
          id: e.id,
          sub_type: subject.object_type,
          sub_id: subject.object_id,
          sub: `${subject.object_type} [${subject.object_id}]`,
          obj_type: object.object_type,
          obj_id: object.object_id,
          obj: `${object.object_type} [${object.object_id}]`,
          rel_type: rel.object_type,
          rel_id: rel.object_id,
          rel_obj: `${rel.object_type} [${rel.object_id}]`,
          ref_type: ref.object_type,
          ref_id: ref.object_id,
          ref_obj: `${ref.object_type} [${ref.object_id}]`,
          source_type: source.object_type,
          source_id: source.object_id,
          source_obj: `${source.object_type} [${source.object_id}]`,
          fromRecipient: source.object_id && source.object_id.toLowerCase().includes('recipient'),
          functions: [
            'lowerCase',
            'upperCase',
            'removeDash',
            'replaceDash',
            'convertMeterToMileString',
            'convertSecondToHour',
            'splitText',
            'capitalizeText',
            'formatDateTime',
            'parseJSON',
            'toJSON',
            'renderLocation',
            'when',
            'whenAnd',
            'whenOr',
            'sum',
          ],
        },
        template: template,
      });
    }
    if (e.signal === 'DATE') {
      template = dataTemplates.find((f) => f.category === 'DATE' && f.type === 'DATE' && f.action === 'date');
      dataMap.set(e.date, {
        origin: e,
        converted: {
          date: e.date,
        },
        template: template,
      });
    }
  }
  return dataMap;
};

export { separateObject, getDotColor, transformEventMap };
